import * as z from 'zod';

// Single source of truth for password rules on the frontend.
// Keep in sync with backend/middleware/validation.js (passwordStrengthRule).

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_COMPLEXITY_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;

export type PasswordTranslateFn = (key: string, options?: Record<string, unknown>) => string;

// Full strength schema: used when SETTING a password (register / reset).
export const createPasswordSchema = (t: PasswordTranslateFn) =>
  z
    .string()
    .min(1, t('validation.passwordRequiredSetting'))
    .min(
      PASSWORD_MIN_LENGTH,
      t('validation.passwordMin', { count: PASSWORD_MIN_LENGTH })
    )
    .regex(PASSWORD_COMPLEXITY_REGEX, t('validation.passwordComplexity'));

// Login only verifies the password is present — never enforce complexity on an
// existing credential (imported/legacy passwords may predate the policy).
export const createLoginPasswordSchema = (t: PasswordTranslateFn) =>
  z.string().min(1, t('validation.passwordRequired'));
